import type { FC } from 'react';
import { useRef } from 'react';
import StudioHeaderMobile from '../../../StudioHeaderMobile';
import LayoutContainer from '../../_partials/LayoutContainer';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import BookmarksListMobile from '../../../bookmarks/BookmarksListMobile';

import s from './BookmarksLayout.scss';

interface Props {}

const BookmarksLayout: FC<Props> = () => {
  const scrollableRef = useRef<HTMLElement | null>(null);

  return (
    <LayoutContainer>
      <StudioHeaderMobile />
      <ScrollableContent
        wrapperClassName={s['content-wrapper']}
        innerRef={el => (scrollableRef.current = el)}
      >
        <BiLoggerContextProvider value={{ sectionname: 'subfolders' }}>
          <div className={s['list-wrapper']}>
            <BookmarksListMobile withDragToOrder withFolderActions />
          </div>
        </BiLoggerContextProvider>
      </ScrollableContent>
    </LayoutContainer>
  );
};
BookmarksLayout.displayName = 'BookmarksLayout';

export default BookmarksLayout;
